export type InventoryRecord = { sourceRow: number; model: string; sizeSeats: string; manufacturer: string; color: string; cabinet: string; smartTub: string; location: string; available: string; notes: string }
export type InventorySnapshot = { retrievedAt: string; records: InventoryRecord[] }

export const INVENTORY_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTdvOREzeAFJYJ1Wxye7hZrD5U7jurvbzD5Jz21iQm5IPCiPj1PU6uYrSSUu00lVUhqfKxpZK0cM2G4/pubhtml?gid=712112742&single=true&widget=true&headers=false"
export const INVENTORY_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTdvOREzeAFJYJ1Wxye7hZrD5U7jurvbzD5Jz21iQm5IPCiPj1PU6uYrSSUu00lVUhqfKxpZK0cM2G4/pub?gid=712112742&single=true&output=csv"
export const initialInventory: InventorySnapshot = {
  "retrievedAt": "2026-10-17T14:32:38.020724+00:00",
  "records": [
    {
      "sourceRow": 2,
      "model": "Edison 680",
      "sizeSeats": "84″ × 84″\nSeats 6",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Graphite",
      "smartTub": "Smart Tub",
      "location": "Grounds",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 3,
      "model": "Edison 680",
      "sizeSeats": "84″ × 84″\nSeats 6",
      "manufacturer": "SD",
      "color": "Travertine",
      "cabinet": "Graphite",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 4,
      "model": "Peyton 680",
      "sizeSeats": "84″ × 84″\nSeats up to 6",
      "manufacturer": "SD",
      "color": "Travertine",
      "cabinet": "Slate",
      "smartTub": "Smart Tub",
      "location": "Floor",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 5,
      "model": "Peyton 680",
      "sizeSeats": "84″ × 84″\nSeats up to 6",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Graphite",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 6,
      "model": "McKinley 680",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Graphite",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 7,
      "model": "McKinley 680",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Graphite",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 8,
      "model": "Bristol 780",
      "sizeSeats": "84″ × 84″\nSeats 5–6",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 9,
      "model": "Bristol 780",
      "sizeSeats": "84″ × 84″\nSeats 5–6",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 10,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Midnight",
      "cabinet": "Modern Hardwood",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 11,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 12,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Platinum",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 13,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Travertine",
      "cabinet": "Modern Hardwood",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 14,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Travertine",
      "cabinet": "Modern Hardwood",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 15,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Brushed Gray",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 16,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Brushed Gray",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 17,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 18,
      "model": "Chelsee 780",
      "sizeSeats": "89″ × 89″\nSeats 6–7",
      "manufacturer": "SD",
      "color": "Morning Mist",
      "cabinet": "Vintage Oak",
      "smartTub": "Smart Tub",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Open Seating"
    },
    {
      "sourceRow": 19,
      "model": "Viking 3",
      "sizeSeats": "72″ round\nSeats 5",
      "manufacturer": "Viking",
      "color": "Opal",
      "cabinet": "Walnut",
      "smartTub": "",
      "location": "Other",
      "available": "Yes",
      "notes": "Round/ Open Seating"
    },
    {
      "sourceRow": 20,
      "model": "Royale X",
      "sizeSeats": "78″ × 78″\nSeats 6",
      "manufacturer": "Viking",
      "color": "Silver",
      "cabinet": "Slate Blk Corners",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 21,
      "model": "Elevate X",
      "sizeSeats": "60″ × 84″\nSeats 3",
      "manufacturer": "Viking",
      "color": "Opal",
      "cabinet": "Chestnut Blk Corners",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 22,
      "model": "Elevate X",
      "sizeSeats": "60″ × 84″\nSeats 3",
      "manufacturer": "Viking",
      "color": "Silver",
      "cabinet": "Carbon",
      "smartTub": "",
      "location": "Warehouse",
      "available": "Yes",
      "notes": "Lounge"
    },
    {
      "sourceRow": 23,
      "model": "Royale P+",
      "sizeSeats": "78″ × 78″\nSeats 6",
      "manufacturer": "Viking",
      "color": "Silver",
      "cabinet": "Coastal",
      "smartTub": "",
      "location": "Floor",
      "available": "Yes",
      "notes": "Lounge"
    }
  ]
}
